/* Grass Seed Calculator — theme asset. Self-contained IIFE, scoped to #gsc-root
   (inside #grass-seed-tool) via querySelector so duplicate theme IDs can't clash. */
(function(){
  var ROOT=document.getElementById('gsc-root');
  if(!ROOT) return;
  var state={ shape:'rect', project:'new' };
  var LIN_TO_FT={ ft:1, yd:3, m:3.280839895 };
  var AREA_TO_SQFT={ sqft:1, sqm:10.76391042, acre:43560, ha:107639.1042 };
  var LB_TO_KG=0.45359237;
  var KITS=[250,500,1000,2500,5000,7500,10000];
  var COLLECTION_URL='https://eartheasy.com/collections/yard-garden-natural-lawn-care';
  var PRODUCTS={
    eco:{url:'https://eartheasy.com/products/wildflower-farms-eco-lawn-low-maintenance-grass-seed',img:'https://eartheasy.com/cdn/shop/files/wildflower-farms-eco-lawn-grass-seed-5-lbsw5500-2692685.jpg?v=1782489490&width=300',alt:"Wildflower Farm's Eco-Lawn low-maintenance grass seed, 5 lb bag",cta:'Shop Eco-Lawn grass seed →'},
    microlawn:{url:'https://eartheasy.com/products/microlawn-grass-seed-microclover-blend-5-lbs',img:'https://cdn.shopify.com/s/files/1/0670/4542/5197/files/microlawn-grass-seed-microclover-blend-5-lbsuct144-5-1586331.jpg?v=1782488580&width=300',alt:'MicroLawn grass seed and microclover blend, 5 lb bag',cta:'Shop MicroLawn seed →'},
    mclover:{url:'https://eartheasy.com/products/microclover-seed-1-lb',img:'https://cdn.shopify.com/s/files/1/0670/4542/5197/files/microclover-seed-1-lbuct145-4193011.jpg?v=1782489363&width=300',alt:'Microclover seed, 1 lb bag',cta:'Shop Microclover seed →'},
    thyme:{url:'https://eartheasy.com/products/creeping-thyme-easy-spread-shaker',img:'https://cdn.shopify.com/s/files/1/0670/4542/5197/files/creeping-thyme-flowering-lawn-groundcover-seed-kit-8431144.jpg?v=1782488228&width=300',alt:'Creeping Thyme flowering lawn seed kit',cta:'Shop Creeping Thyme kits →'}
  };
  function $(id){ return ROOT.querySelector('#'+id); }

  var shapeBtns=ROOT.querySelectorAll('#gsc-shapes button');
  shapeBtns.forEach(function(b){
    b.addEventListener('click',function(){
      state.shape=b.dataset.shape;
      shapeBtns.forEach(function(x){ x.setAttribute('aria-pressed', x===b?'true':'false'); });
      ROOT.querySelectorAll('.gsc-dims').forEach(function(d){ d.style.display = d.dataset.for===state.shape ? '' : 'none'; });
      calc();
    });
  });
  ROOT.querySelectorAll('#gsc-project button').forEach(function(b){
    b.addEventListener('click',function(){
      state.project=b.dataset.proj;
      ROOT.querySelectorAll('#gsc-project button').forEach(function(x){ x.setAttribute('aria-pressed', x===b?'true':'false'); });
      calc();
    });
  });
  $('gsc-adv-btn').addEventListener('click',function(){
    var a=$('gsc-adv'), open=a.classList.toggle('open');
    this.setAttribute('aria-expanded', open?'true':'false');
    this.textContent=(open?'－ Fewer options':'＋ More options (bag size, price, custom rate)');
  });
  $('grass').addEventListener('change',function(){
    var isCustom=this.value==='custom';
    $('custom-rate-field').style.display=isCustom?'':'none';
    if(isCustom){
      $('gsc-adv').classList.add('open');
      $('gsc-adv-btn').setAttribute('aria-expanded','true');
      $('gsc-adv-btn').textContent='－ Fewer options';
      var rc=$('rate-custom'); rc.classList.remove('gsc-flash'); void rc.offsetWidth; rc.classList.add('gsc-flash'); rc.focus();
    }
    updateProduct();
    calc();
  });
  $('lin-unit').addEventListener('change',function(){
    var lbl=this.options[this.selectedIndex].text;
    $('c-unit-lbl').textContent=lbl; $('t-unit-lbl').textContent=lbl; calc();
  });
  ['r-len','r-wid','c-rad','t-base','t-hgt','a-val','area-unit','rate-custom','bag','price','grass'].forEach(function(id){
    var el=$(id); if(el){ el.addEventListener('input',calc); el.addEventListener('change',calc); }
  });
  function num(id){ var v=parseFloat($(id).value); return isNaN(v)||v<0?0:v; }
  function areaSqFt(){
    var u=$('lin-unit').value, f=LIN_TO_FT[u];
    if(state.shape==='rect'){ return num('r-len')*f * num('r-wid')*f; }
    if(state.shape==='circle'){ var r=num('c-rad')*f; return Math.PI*r*r; }
    if(state.shape==='triangle'){ return 0.5*num('t-base')*f*num('t-hgt')*f; }
    if(state.shape==='area'){ return num('a-val')*AREA_TO_SQFT[$('area-unit').value]; }
    return 0;
  }
  function rate(){
    var g=$('grass'), opt=g.options[g.selectedIndex];
    if(g.value==='custom'){ return num('rate-custom'); }
    return parseFloat(state.project==='new'?opt.dataset.new:opt.dataset.over)||0;
  }
  function fmt(n){ if(n>=100) return n.toFixed(0); if(n>=10) return n.toFixed(1); return n.toFixed(2); }
  function commas(n){ return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','); }
  function isKit(){ var g=$('grass'); return !!g.options[g.selectedIndex].dataset.kit; }
  function kitPlan(area){
    var max=KITS[KITS.length-1], left=area, plan={};
    function add(k){ plan[k]=(plan[k]||0)+1; }
    while(left>max){ add(max); left-=max; }
    for(var i=0;i<KITS.length;i++){ if(KITS[i]>=left){ add(KITS[i]); break; } }
    return plan;
  }
  function updateProduct(){
    var p=PRODUCTS[$('grass').value], prod=$('gsc-prod'), cta=$('gsc-cta');
    if(p){
      prod.style.display=''; prod.href=p.url; prod.setAttribute('aria-label',p.alt);
      $('gsc-prod-img').src=p.img; $('gsc-prod-img').alt=p.alt;
      cta.href=p.url; cta.textContent=p.cta;
    } else {
      prod.style.display='none';
      cta.href=COLLECTION_URL; cta.textContent='Shop the Natural Lawn Care collection →';
    }
  }
  function emptyState(showErr){
    var err=$('gsc-err');
    $('out-head').textContent='Enter your lawn size';
    $('out-lbs').textContent='—'; $('out-lbs').classList.add('empty'); $('out-kg').textContent='';
    $('out-stats').style.display='none';
    err.textContent = showErr ? (state.shape==='area'?'Enter your lawn area to see a result.':'Enter your lawn dimensions to see a result.') : '';
    err.style.display = showErr?'block':'none';
  }
  function calc(){
    var kit=isKit(), err=$('gsc-err');
    $('gsc-project-fs').style.display=kit?'none':'';
    $('gsc-adv-btn').style.display=kit?'none':'';
    if(kit){
      $('gsc-adv').classList.remove('open');
      $('gsc-adv-btn').setAttribute('aria-expanded','false');
      $('gsc-adv-btn').textContent='＋ More options (bag size, price, custom rate)';
    }
    var area=areaSqFt();
    if(kit){
      if(area<=0){ emptyState(hasInput()); return; }
      err.textContent=''; err.style.display='none';
      var plan=kitPlan(area), sizes=Object.keys(plan).map(Number).sort(function(a,b){return b-a;});
      var totalKits=0, totalCov=0, parts=[];
      sizes.forEach(function(k){ totalKits+=plan[k]; totalCov+=k*plan[k]; parts.push((plan[k]>1?plan[k]+' × ':'')+commas(k)+' sq ft'); });
      $('out-head').textContent="You'll need"; $('out-lbs').classList.remove('empty');
      if(totalKits===1){
        $('out-lbs').innerHTML=commas(sizes[0])+' <span>sq ft kit</span>';
        $('out-kg').textContent='1 kit covers up to '+commas(sizes[0])+' sq ft';
      } else {
        $('out-lbs').innerHTML=totalKits+' <span>kits</span>';
        $('out-kg').textContent=parts.join(' + ');
      }
      $('out-stats').style.display='';
      $('out-area').textContent=commas(Math.round(area))+' sq ft';
      $('out-rate-lbl').textContent='Kit coverage';
      $('out-rate').textContent='up to '+commas(totalCov)+' sq ft';
      $('row-bags').style.display='none'; $('row-cost').style.display='none';
      var kitTxt = totalKits===1 ? 'the '+commas(sizes[0])+' sq ft kit' : parts.join(' + ')+' kits';
      $('out-note').innerHTML='Creeping thyme is sold as <b>coverage-based kits</b>, not by the pound. For your '+commas(Math.round(area))+' sq ft, get '+kitTxt+' — sow over prepared soil or an existing lawn.';
      return;
    }
    $('out-rate-lbl').textContent='Seeding rate';
    var r=rate();
    if(area<=0 || r<=0){
      emptyState(area<=0 && hasInput());
      return;
    }
    err.textContent=''; err.style.display='none';
    $('out-head').textContent="You'll need about"; $('out-lbs').classList.remove('empty');
    var lbs=(area/1000)*r, kg=lbs*LB_TO_KG;
    $('out-lbs').innerHTML=commas(fmt(lbs))+' <span>lbs</span>';
    $('out-kg').textContent='≈ '+commas(fmt(kg))+' kg of grass seed';
    $('out-stats').style.display='';
    $('out-area').textContent=commas(Math.round(area))+' sq ft';
    $('out-rate').textContent=r+' lbs / 1,000 sq ft';
    var bag=num('bag');
    if(bag>0){ $('row-bags').style.display=''; $('out-bags').textContent=Math.ceil(lbs/bag)+' × '+fmt(bag)+' lb bag'+(Math.ceil(lbs/bag)>1?'s':''); }
    else { $('row-bags').style.display='none'; }
    var price=num('price');
    if(price>0){ $('row-cost').style.display=''; $('out-cost').textContent='$'+commas((lbs*price).toFixed(2)); }
    else { $('row-cost').style.display='none'; }
    var g=$('grass'), name=g.options[g.selectedIndex].text;
    $('out-note').innerHTML='For <b>'+(state.project==='new'?'a new '+name+' lawn':'overseeding '+name)+
      '</b>, plan for about <b>'+commas(fmt(lbs))+' lbs</b> across '+commas(Math.round(area))+
      ' sq ft. Apply half in one direction and half crosswise for even coverage.';
  }
  function hasInput(){ return ['r-len','r-wid','c-rad','t-base','t-hgt','a-val'].some(function(id){ return $(id).value!==''; }); }
  updateProduct();
  calc();
})();
